module.exports = __webpack_public_path__ + "img/edit-icon.98d562a8.svg";